/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconOmega = createReactComponent("omega", "IconOmega", [
  ["path", { d: "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5", key: "svg-0" }]
]);

export { IconOmega as default };
//# sourceMappingURL=IconOmega.js.map
